/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import Input, { PickLayerService } from 'components/g3w-input';

  const __vue_script__ = {

    /** @since 3.8.6 */
    name: 'input-picklayer',

    mixins: [ Input ],
    methods: {
      pickLayer() {
        this.pickservice.pick()
          .then(value => this.state.value = value).catch(()=>{})
      },
      unpick() {
        setTimeout(() => !this.pickservice.isPicked() && this.pickservice.unpick(), 200)
      }
    },
    created() {
      this.pickservice = new PickLayerService(this.state.input.options)
    },
    beforeDestroy() {
      this.pickservice.clear();
      this.pickservice = null;
    }
  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('span',{staticClass:"skin-color",class:_vm.g3wtemplate.font['crosshairs'],staticStyle:{"left":"0","top":"7px","position":"absolute"}}),_vm._v(" "),_c('input',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.editable),expression:"!editable"},{name:"model",rawName:"v-model",value:(_vm.state.value),expression:"state.value"}],staticClass:"form-control",class:{'input-error-validation' : _vm.notvalid},staticStyle:{"width":"100%"},style:({cursor: _vm.editable ? 'pointer': null}),attrs:{"readonly":"readonly","tabIndex":_vm.tabIndex},domProps:{"value":(_vm.state.value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.state, "value", $event.target.value)},_vm.change],"click":_vm.pickLayer,"blur":_vm.unpick}})])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InputPickLayer.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__